<script lang="ts">
    import type { Widget } from "../store";
    import { PaletteType, widgetInfo } from "../store";

    let palette: PaletteType = PaletteType.DARK;
    widgetInfo.subscribe((value: Widget) => {
        if (value) palette = value.theme;
    });
</script>

<svelte:head>
    <style>
        @import url("https://use.typekit.net/uax1qqw.css");
    </style>

    {#if palette == PaletteType.DARK}
        <style lang="css">
            :root {
                --success-color: #b3f1b5;
                --error-color: #ee7064;
                --warning-color: #eaef80;
                --default-color: #ffffff;
                --primary-color: #ffffff;
                --info-color: rgba(0, 0, 0, 0);
                --title-color: #ffffff;
                --background-color: #121a24;
                --chill-color: #7dfbfb;
            }
        </style>
    {:else}
        <style lang="css">
            :root {
                --success-color: #75d27e;
                --error-color: #ee7064;
                --warning-color: #ebef8b;
                --default-color: #000000;
                --primary-color: #ffffff;
                --info-color: rgba(125, 222, 251, 0.25);
                --title-color: #767f8a;
                --background-color: #ffffff;
                --chill-color: #56a8cb;
            }
        </style>
    {/if}

    <style lang="css">
        *,
        *::before,
        *::after {
            box-sizing: inherit;
        }
        html {
            box-sizing: border-box;
            font-size: 62.5%;
        }
        body {
            color: #606c76;
            font-size: 1.6rem;
            font-family: proxima-nova;
            font-weight: 300;
            /* letter-spacing: 0.1rem; */
            line-height: 1.6;
        }

        b,
        strong {
            font-weight: bold;
        }
        p {
            margin-top: 0;
        }
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            font-weight: 300;
            letter-spacing: -0.1rem;
            margin-bottom: 2rem;
            margin-top: 0;
        }
        h1 {
            font-size: 4.6rem;
            line-height: 1.2;
        }
        h2 {
            font-size: 3.6rem;
            line-height: 1.25;
        }
        h3 {
            font-size: 2.8rem;
            line-height: 1.3;
        }
        h4 {
            font-size: 2.2rem;
            line-height: 1.35;
            letter-spacing: -0.08rem;
        }
        h5 {
            font-size: 1.8rem;
            line-height: 1.5;
            letter-spacing: -0.05rem;
        }
        h6 {
            font-size: 1.5rem;
            line-height: 1.4;
            letter-spacing: 0;
        }

        .timer-label {
            font-variant-numeric: tabular-nums;
        }
        .body {
            padding: 0;
            margin: 0;
            font-family: proxima-nova !important;
        }
        .pw-container {
            margin: 0 auto;
            position: relative;
            width: 100%;
        }
        .pw-card {
            width: 100%;
            height: 100%;
            padding: 20px;
            padding-bottom: 0px;
            display: flex;
            flex-direction: column;
            background: var(--background-color);
            border-radius: 10px;
            -ms-overflow-style: none; /* IE and Edge */
            scrollbar-width: none; /* Firefox */
        }
        .pw-card::-webkit-scrollbar {
            display: none;
        }
        .pw-justify-center {
            justify-content: center;
        }
        .pw-justify-between {
            justify-content: space-between;
        }
        .pw-justify-end {
            justify-content: flex-end;
        }
        .pw-justify-around {
            justify-content: space-around;
        }
        .pw-align-center {
            align-items: center;
        }
        .pw-align-end {
            align-items: flex-end;
        }
        .pw-align-start {
            align-items: flex-start;
        }
        .pw-flex {
            display: flex;
        }
        .pw-flex-column {
            display: flex;
            flex-direction: column;
        }
        .svg-content {
            position: absolute;
            top: 0;
            left: 0;
        }
        .svg-box {
            width: 100%;
            height: 0;
            padding-top: 100%; /* Aspect ratio */
            position: relative;
        }
        @media (min-width: 1000px) {
            .pw-card {
                border-radius: 0px;
            }
        }
        .cc-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
        }

        .value,
        .primary-value,
        .cc-label {
            text-align: center;
            font-weight: 300;
        }

        /* .primary-value, .primary-label, .timer-label, .radius-label {
      text-shadow: 0 0 .5rem #000;
    }
    .lightning-circle svg{
      filter: drop-shadow(0 0 .2rem #000);
    }
    */
        .value {
            font-weight: 300;
            font-size: 16px;
        }
        .label {
            font-size: 9px;
        }

        .cc-icon,
        .cc-label {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .header-message {
            color: #7ddefb;
            border: 1px solid #7ddefb;
            background-color: #1f4676;
            border-radius: 10px;
            margin-bottom: 10px;
            box-shadow: 5px 5px 16px 0px rgba(0, 0, 0, 0.5);
            font-weight: 400;
            text-align: left;
            padding: 10px;
        }

        .lightning-circle {
            width: 30px;
        }
        .timer-base,
        .timer-bar,
        .clear-bar {
            stroke-width: 0.4rem;
        }

        @media (min-width: 300px) {
            .primary-value {
                font-size: 40px;
            }
            .value {
                font-size: 20px;
            }
            .label {
                font-size: 16px;
            }
            .primary-label {
                font-size: 20px;
            }
            .radius-label {
                font-size: 20px;
            }
            .timer-label {
                font-size: 30px;
            }
            .def-container .primary-value {
                font-size: 50px;
            }
            .def-container .primary-label {
                font-size: 20px;
            }
            .def-container .timer-label {
                font-size: 40px;
            }
            .def-container .radius-label {
                font-size: 20px !important;
            }
            .weatherIcon {
                width: 25px;
            }
            .lightning-timer-container {
                display: flex;
                flex-direction: row;
                gap: 2vw;
            }
            .def-container .lightning-timer-container {
                flex-direction: column;
                align-items: center;
            }
            .lightning-circle {
                width: 40px;
            }
            .lightning-info {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
            }
            .def-container .lightning-info {
                align-items: center;
            }
        }

        @media (min-width: 400px) {
            .primary-value {
                font-size: 60px;
            }
            .value {
                font-size: 14px;
            }
            .label {
                font-size: 8px;
            }
            .primary-label {
                font-size: 40px;
            }
            .radius-label {
                font-size: 30px;
            }
            .timer-label {
                font-size: 40px;
            }
            .def-container .primary-value {
                font-size: 75px;
            }
            .def-container .primary-label {
                font-size: 20px;
            }
            .def-container .timer-label {
                font-size: 50px;
            }
            .def-container .radius-label {
                font-size: 30px !important;
            }
            .weatherIcon {
                width: 18px;
            }
            .lightning-circle {
                width: 50px;
            }
        }

        @media (min-width: 600px) {
            .primary-value {
                font-size: 60px;
            }
            .value {
                font-size: 20px;
            }
            .label {
                font-size: 14px;
            }
            .primary-label {
                font-size: 40px;
            }
            .radius-label {
                font-size: 30px;
            }
            .timer-label {
                font-size: 50px;
            }
            .def-container .primary-value {
                font-size: 100px;
            }
            .def-container .primary-label {
                font-size: 50px;
            }
            .def-container .radius-label {
                font-size: 40px !important;
            }
            .def-container .timer-label {
                font-size: 75px !important;
            }
            .weatherIcon {
                width: 30px;
            }
            .lightning-circle {
                width: 75px;
            }
        }

        @media (min-width: 769px) {
            .primary-value {
                font-size: 80px;
            }
            .value {
                font-size: 25px;
            }
            .label {
                font-size: 18px;
            }
            .primary-label {
                font-size: 50px;
            }
            .radius-label {
                font-size: 40px;
            }
            .timer-label {
                font-size: 60px;
            }
            .def-container .primary-value {
                font-size: 150px;
            }
            .def-container .primary-label {
                font-size: 50px;
            }
            .def-container .radius-label {
                font-size: 50px !important;
            }
            .def-container .timer-label {
                font-size: 90px !important;
            }
            .weatherIcon {
                width: 30px;
            }
            .lightning-circle {
                width: 100px;
            }
        }

        @media (min-width: 1000px) {
            html {
                font-size: 20px;
            }

            html:has(.has-message) {
                font-size: 15px;
            }

            .primary-value {
                font-size: 6rem;
            }
            .value {
                font-size: 2rem;
            }
            .label {
                font-size: 1rem;
            }
            .primary-label {
                font-size: 3rem;
            }
            .radius-label {
                font-size: 3rem;
            }
            .timer-label {
                font-size: 4rem;
            }
            .def-container .primary-value {
                font-size: 8rem;
            }
            .def-container .primary-label {
                font-size: 4rem;
            }
            .def-container .timer-label {
                font-size: 6rem !important;
            }
            .def-container .radius-label {
                font-size: 3rem !important;
            }
            .weatherIcon {
                width: 2rem;
            }
            .lightning-circle {
                width: 8rem;
            }
            .timer-base,
            .timer-bar,
            .clear-bar {
                stroke-width: 0.2rem;
            }
        }

        @media (min-width: 1920px) {
            html {
                font-size: 24px;
            }

            html:has(.has-message) {
                font-size: 20px;
            }

            .primary-value {
                font-size: 6rem;
            }
            .value {
                font-size: 2rem;
            }
            .label {
                font-size: 1rem;
            }
            .primary-label {
                font-size: 3rem;
            }
            .radius-label {
                font-size: 3rem;
            }
            .timer-label {
                font-size: 4rem;
            }
            .def-container .primary-value {
                font-size: 8rem;
            }
            .def-container .primary-label {
                font-size: 4rem;
            }
            .def-container .timer-label {
                font-size: 6rem !important;
            }
            .def-container .radius-label {
                font-size: 3rem !important;
            }
            .weatherIcon {
                width: 2rem;
            }
            .lightning-circle {
                width: 8rem;
            }
            .timer-base,
            .timer-bar,
            .clear-bar {
                stroke-width: 0.2rem;
            }
        }

        @media (min-width: 3000px) {
            html {
                font-size: 50px;
            }

            html:has(.has-message) {
                font-size: 45px;
            }

            .primary-value {
                font-size: 6rem;
            }
            .value {
                font-size: 2rem;
            }
            .label {
                font-size: 1rem;
            }
            .primary-label {
                font-size: 3rem;
            }
            .radius-label {
                font-size: 3rem;
            }
            .timer-label {
                font-size: 4rem;
            }
            .def-container .primary-value {
                font-size: 8rem;
            }
            .def-container .primary-label {
                font-size: 4rem;
            }
            .def-container .timer-label {
                font-size: 6rem !important;
            }
            .def-container .radius-label {
                font-size: 3rem !important;
            }
            .weatherIcon {
                width: 2rem;
            }
            .lightning-circle {
                width: 8rem;
            }
            .timer-base,
            .timer-bar,
            .clear-bar {
                stroke-width: 0.1rem;
            }
        }
    </style>
</svelte:head>
